/** Vietnamese UI strings. Keys mirror EN in i18n.ts; a missing key falls back to English. */
export const VI: Record<string, string> = {
  player: "Người chơi",
  nickname: "Biệt danh",
  language: "Ngôn ngữ",
  scene: "Khung cảnh",
  sceneDay: "Ngày",
  sceneNight: "Đêm",
  weatherClear: "Quang",
  weatherRain: "Mưa",
  weatherSnow: "Tuyết",
  pieces: "Quân cờ",
  piecesTrad: "Chữ Hán",
  piecesSimp: "Giản thể",
  piecesWestern: "Chữ cái",
  piecesSymbol: "Ký hiệu",
  soundOn: "🔊 Âm thanh",
  soundOff: "🔇 Tắt tiếng",
  playBot: "Chơi với máy",
  playBotSub: "Máy mạnh · 5 cấp độ · có gợi ý",
  playOnline: "Chơi trực tuyến",
  playOnlineSub: "Ghép ngay với một người lạ",
  playFriends: "Chơi với bạn bè",
  playFriendsSub: "Phòng riêng, gửi đường link",
  lessons: "Bài học",
  lessonsSub: "Học cờ tướng từng bước",
  homeNote: "Kéo hoặc bấm vào quân để đi. Quân đang bị đe doạ sẽ được đánh dấu.",

  botTitle: "Chọn đối thủ",
  difficulty: "Độ khó",
  yourSide: "Bên của bạn",
  beginner: "Rất dễ",
  easy: "Dễ",
  medium: "Vừa",
  hard: "Khó",
  master: "Cao thủ",
  sideRed: "Đỏ",
  sideBlack: "Đen",
  sideRandom: "Ngẫu nhiên",
  back: "Quay lại",
  start: "Bắt đầu",

  friendsTitle: "Chơi với bạn bè",
  friendsDesc: "Tạo phòng rồi gửi link cho bạn, hoặc nhập mã phòng của bạn ấy.",
  createRoom: "Tạo phòng",
  roomCodePlaceholder: "MÃ PHÒNG",
  join: "Vào",
  searching: "Đang tìm đối thủ…",
  creating: "Đang tạo phòng…",
  joining: "Đang vào phòng",
  cancel: "Huỷ",
  /* góp ý */
  fbTitle: "Gửi góp ý",
  fbFromGame: "Ván vừa rồi có gì trục trặc? Báo cho chúng tôi",
  fbSub: "Cho chúng tôi biết chỗ nào bị lỗi, còn thiếu gì, hoặc bạn thích điều gì. Chúng tôi đọc hết.",
  fbOpen: "Viết cho chúng tôi",
  fbWhat: "Nội dung",
  fbBug: "Có lỗi",
  fbIdea: "Một ý tưởng",
  fbPraise: "Điều hay",
  fbOther: "Khác",
  fbPlaceholder: "Chuyện gì đã xảy ra, và bạn mong đợi điều gì?",
  fbEmailHint: "Email, nếu bạn muốn được trả lời (không bắt buộc)",
  fbSend: "Gửi",
  fbSending: "Đang gửi...",
  fbThanks: "Cảm ơn bạn — chúng tôi đã nhận được.",
  fbEmpty: "Bạn hãy viết gì đó trước đã.",
  fbFailed: "Chưa gửi được. Nội dung của bạn vẫn còn đây — thử lại nhé.",
  fbDiscordTitle: "Tham gia cộng đồng Discord",
  fbDiscordText: "Trò chuyện với người chơi khác, và báo lỗi trực tiếp cho chúng tôi.",
  fbDiscordJoin: "Tham gia",
  /* lời mời góp ý định kỳ, và phần chấm điểm */
  fbAskTitle: "Bạn có nửa phút không?",
  fbAskSub: "Chúng tôi muốn biết trải nghiệm của bạn thế nào — điều gì ổn, điều gì chưa. Chưa tới 30 giây.",
  fbAskYes: "Gửi góp ý",
  fbAskLater: "Để sau",
  fbAskNever: "Không, cảm ơn",
  fbRate: "Nhìn chung bạn thấy thế nào?",
  fbRateSkip: "(không bắt buộc)",
  fbRate1: "Tệ",
  fbRate5: "Tuyệt",
  fbImprove: "Chúng tôi nên cải thiện gì?",
  groupFeedback: "Góp ý",
  groupFeedbackSub: "Cho chúng tôi biết chỗ nào sai hoặc còn thiếu",
  roomLabel: "Phòng",
  shareLink: "Gửi link này cho bạn của bạn:",
  copy: "Sao chép",
  copiedShort: "Đã chép",
  chatEmpty: "Chưa có tin nhắn. Chào một câu nhé.",
  watchingCount: "{n} người xem",
  waitingOpponent: "Đang chờ đối thủ…",

  redToMove: "Đỏ đi",
  blackToMove: "Đen đi",
  gameOver: "Hết ván",
  yourMove: "Lượt bạn",
  opponentMove: "Lượt đối thủ",
  botThinking: "Máy đang nghĩ…",
  check: "Chiếu!",
  repWarnCheckShort: "Chiếu lặp — hãy đổi nước",
  repWarnChaseShort: "Đuổi lặp — hãy đổi nước",
  repWarnCheck: "Chiếu lặp: nước nào bạn cũng chiếu và thế cờ đang lặp lại. Lặp thêm một lần nữa là bạn bị xử thua (luật WXF). Hãy đổi nước.",
  repWarnChase: "Đuổi lặp: nước nào bạn cũng đuổi cùng một quân và thế cờ đang lặp lại. Lặp thêm một lần nữa là bạn bị xử thua (luật WXF). Hãy đổi nước.",
  hint: "Gợi ý",
  hintThinking: "Đang tìm gợi ý…",
  undo: "Đi lại",
  newGame: "Ván mới",
  home: "Trang chủ",
  resign: "Xin thua",
  rematch: "Đấu lại",
  movesTitle: "Biên bản",
  you: "Bạn",
  bot: "Máy",
  match: "Ván đấu",
  opponentDisconnected: "Đối thủ mất kết nối…",
  rematchOffered: "Đối thủ muốn đấu lại",

  reviewMode: "Chế độ xem lại · không đi được",
  toLive: "Về ván đang chơi",
  navStart: "Đầu",
  navPrev: "Trước",
  navNext: "Sau",
  navLive: "Mới nhất",
  noMovesYet: "Chưa có nước nào — Đỏ đi trước",

  dockBack: "Lùi",
  dockFwd: "Tiến",
  dockMore: "Thêm",
  sheetMore: "Ván này",
  sheetClose: "Đóng",

  youWin: "Bạn thắng!",
  youLose: "Bạn thua",
  draw: "Hoà",
  redWins: "Đỏ thắng",
  blackWins: "Đen thắng",
  reviewBoard: "Xem lại bàn cờ",
  reasonCheckmate: "Chiếu bí",
  reasonStalemate: "Hết nước đi — không còn nước hợp lệ là thua",
  reasonTimeout: "Hết giờ",
  reasonResign: "Xin thua",
  reasonAbandon: "Đối thủ đã rời đi",
  reasonRepetition: "Lặp thế cờ ba lần",
  reasonPerpetualCheck: "Chiếu lặp — thế cờ lặp lại ba lần trong khi một bên nước nào cũng chiếu; theo luật WXF, bên chiếu mãi không đổi nước bị xử thua",
  reasonPerpetualChase: "Đuổi lặp — thế cờ lặp lại ba lần trong khi một bên nước nào cũng đuổi cùng một quân; theo luật WXF, bên đuổi mãi không đổi nước bị xử thua",
  reasonDraw: "Hoà (luật 60 nước)",

  offerDraw: "Cầu hoà",
  drawOfferedTitle: "Lời cầu hoà",
  drawOfferedBody: "Đối thủ của bạn xin hoà.",
  accept: "Đồng ý",
  decline: "Từ chối",
  drawDeclined: "Đã từ chối hoà",
  drawOfferSent: "Đã gửi lời cầu hoà",
  drawOfferWait: "Lời cầu hoà đã được gửi. Hãy chờ trả lời; một lát nữa bạn mới có thể cầu hoà lại.",
  rematchTitle: "Đấu lại?",
  rematchBody: "Đối thủ của bạn muốn đấu lại.",
  connected: "Đã kết nối",
  reconnecting: "Đang kết nối lại…",
  reasonAgreement: "Hai bên đồng ý hoà",
  logIn: "Đăng nhập",
  signUp: "Đăng ký",
  logOut: "Đăng xuất",
  username: "Tên đăng nhập",
  usernameOrEmail: "Tên đăng nhập hoặc email",
  usernameRule: "2–16 ký tự: chữ Hán, chữ cái, số hoặc _ (ít nhất 3 nếu không có chữ Hán)",
  authFillBoth: "Vui lòng nhập tên đăng nhập và mật khẩu.",
  authCreateNamed: "Tạo tài khoản tên “{name}” →",
  authErr_username_invalid: "Tên đăng nhập chỉ gồm chữ Hán, chữ cái, số hoặc _, dài 2–16 ký tự (ít nhất 3 nếu không có chữ Hán).",
  authErr_email_invalid: "Vui lòng nhập địa chỉ email hợp lệ.",
  authErr_password_short: "Mật khẩu phải có ít nhất 8 ký tự.",
  authErr_username_taken: "Tên đăng nhập này đã có người dùng. Hãy thử tên khác.",
  authErr_email_taken: "Email này đã được đăng ký.",
  authErr_no_account: "Không có tài khoản nào với tên đăng nhập này.",
  authErr_bad_credentials: "Sai tên đăng nhập hoặc mật khẩu.",
  authErr_rate_limited: "Thử quá nhiều lần. Chờ một lát rồi thử lại.",
  email: "Email",
  password: "Mật khẩu",
  displayName: "Tên hiển thị",
  account: "Tài khoản",
  signedInAs: "Đăng nhập với tên",
  loginTitle: "Đăng nhập",
  signupTitle: "Tạo tài khoản",
  needAccount: "Chưa có tài khoản? Đăng ký",
  haveAccount: "Đã có tài khoản? Đăng nhập",
  agreePre: "Khi tạo tài khoản, bạn đồng ý với ",
  agreeMid: " và ",
  agreePost: ".",
  termsLink: "Điều khoản sử dụng",
  privacyLink: "Chính sách quyền riêng tư",
  continueWithGoogle: "Tiếp tục với Google",
  orDivider: "hoặc",
  googleCancelled: "Đã huỷ đăng nhập.",
  playAsGuest: "Chơi với tư cách khách",
  searchingAlone: "Hiện chưa có ai khác đang online.",
  playBotInstead: "Chuyển sang chơi với máy",
  elapsed: "Đã chờ",
  analysis: "Phân tích",
  analysisSub: "Máy phân tích & nghiên cứu",
  puzzles: "Thế cờ",
  puzzlesSub: "Luyện chiến thuật",
  // thế cờ mỗi ngày
  dailyTitle: "Thế cờ hôm nay",
  dailySub: "Mỗi ngày một thế, ai cũng giải cùng một thế",
  dailyPrompt: "Thế cờ hôm nay. Đỏ đi — chỉ cần một nước.",
  dailyStreak: "Chuỗi ngày",
  bestStreak: "Kỷ lục",
  dailyDone: "Đã giải.",
  dailyAlready: "Bạn đã giải thế hôm nay rồi.",
  dailyToday: "Thế cờ hôm nay",
  dailyGo: "Giải ngay",
  dailyDoneShort: "Hôm nay đã xong",
  morePuzzles: "Thêm thế cờ",
  shareStreak: "Chia sẻ",
  copied: "Đã sao chép.",
  // bốn đối thủ ở /play/computer
  botIntro: "Năm đối thủ, mỗi người một kiểu. Mọi con số trên thẻ đều là thông số thật của máy.",
  botBeginnerName: "Người mới",
  botBeginnerStyle: "Vừa mới biết đi quân. Chỉ nhìn trước một nước, hay để quân bị ăn không và có khi bỏ lỡ cả nước chiếu bí ngay trước mắt. Mới làm quen cờ tướng thì bắt đầu từ đây.",
  botEasyName: "Cậu học trò",
  botEasyStyle: "Đi nhanh, không tính xa, hay để mất quân. Thắng được Người mới rồi thì đến lượt cậu học trò này.",
  botMediumName: "Khách quán trà",
  botMediumStyle: "Chơi chắc. Biết trừng phạt lỗi rõ ràng, nhưng không tìm ra nước nào sâu.",
  botHardName: "Kỳ thủ câu lạc bộ",
  botHardStyle: "Nhìn ra đòn chiến thuật trước vài nước. Bạn cần có kế hoạch, không chỉ đi nước tốt.",
  botMasterName: "Đại sư",
  botMasterStyle: "Tính rất sâu và hầu như không sai. Hãy chuẩn bị tinh thần thua một thời gian.",
  plies: "nửa nước",
  ply: "nửa nước",
  botSlips: "nước cố ý đi sai",
  botNote: "Ván chơi với máy không tính điểm và không cần tài khoản. Mọi thứ chạy ngay trong trình duyệt của bạn.",
  resumeBotTitle: "Bạn có một ván đang dở",
  resumeBot: "Chơi tiếp",
  discardBot: "Bỏ ván",
  movesLower: "nước",
  // bảng xếp hạng
  leaderboardIntro: "Xếp theo điểm, top 50. Chỉ tính ván xếp hạng.",
  youTag: "bạn",
  gamesLower: "ván",
  notRankedYet: "Bạn chưa lọt top 50. Chỉ cần vài ván xếp hạng.",
  // xem lại ván đã xong
  reviewGame: "Phân tích ván này",
  reviewing: "Đang xem lại",
  reviewNote: "Chạy trong trình duyệt của bạn; ván cờ không bị tải lên. Khoảng nửa phút cho cả ván.",
  reviewPickMove: "Chọn một nước để xem nó làm mất bao nhiêu.",
  avgLoss: "Mất TB",
  betterWas: "Nước tốt hơn",
  cost: "mất",
  verdict_best: "Nước tốt nhất",
  verdict_good: "Tốt",
  verdict_inaccuracy: "Thiếu chính xác",
  verdict_mistake: "Sai lầm",
  verdict_blunder: "Nước hớ",
  evaluation: "Đánh giá",
  bestMoveLabel: "Nước tốt nhất",
  engineOn: "Bật máy",
  engineOff: "Máy đang tắt",
  showBest: "Xem gợi ý",
  flip: "Xoay bàn cờ",
  puzzlePrompt: "Đỏ đi — tìm nước hay nhất",
  correctPuzzle: "Đã giải!",
  wrongPuzzle: "Chưa đúng — thử lại",
  nextPuzzle: "Thế tiếp theo",
  skip: "Bỏ qua",
  streak: "Chuỗi",
  solvedCount: "Đã giải",
  allSolved: "Xong hết rồi! Lần sau quay lại nhé.",
  theme: "Giao diện",
  leaderboard: "Bảng xếp hạng",
  leaderboardSub: "Xếp theo điểm",
  ratedOnly: "Chỉ tính ván xếp hạng",
  noRatedGames: "Chưa có ván xếp hạng nào.",
  rating: "Điểm",
  games: "Ván",
  gameInProgress: "Ván đang diễn ra",
  rejoin: "Vào lại ván",
  vs: "vs",
  resignConfirm: "Xin thua ván này?",
  resignConfirmBody: "Ván cờ sẽ kết thúc. Không thể rút lại.",
  closeModal: "Đóng",
  leaveGameTitle: "Ván của bạn vẫn đang diễn ra",
  leaveGameBody: "Bạn có thể quay lại sau, hoặc xin thua ngay.",
  keepPlaying: "Chơi tiếp",
  leaveBotBody: "Rời đi lúc này sẽ kết thúc ván với máy. Chơi tiếp hay thoát?",
  exitGame: "Thoát ván",
  leaveForNow: "Tạm rời",
  lessonsTitle: "Bài học",
  progressDone: "đã xong",
  allLessons: "Tất cả bài học",
  prevLesson: "Bài trước",
  nextLesson: "Bài sau",
  reset: "Làm lại",
  taskInfo: "Quan sát bàn cờ",
  taskExplore: "Thử xem: chạm vào quân rồi đi tới một trong các chấm.",
  lessonExplore: "Đúng rồi, đó là một nước đi của nó. Thử chấm khác, hoặc sang bài tiếp theo.",
  taskAnyLegal: "Đi một nước hợp lệ bất kỳ",
  taskMate: "Tìm nước chiếu bí ngay",
  taskMove: "Tìm nước đi",
  correct: "Chính xác!",
  tryAgain: "Chưa đúng — thử lại.",
  profile: "Hồ sơ",
  profileSub: "Thành tích & lịch sử ván đấu",
  recentGames: "Ván gần đây",
  noGames: "Chưa có ván nào — chơi một ván đi!",
  signInForProfile: "Đăng nhập để xem thành tích và lịch sử ván đấu.",
  watchReplay: "Xem lại",
  memberSince: "Thành viên từ",
  wins: "Thắng",
  losses: "Thua",
  draws: "Hoà",
  winRate: "Tỉ lệ thắng",
  replayTitle: "Xem lại ván",
  backToProfile: "Về hồ sơ",
  ratedGame: "Xếp hạng",
  casualGame: "Giao hữu",
  resultRedWin: "Đỏ thắng",
  resultBlackWin: "Đen thắng",
  resultDraw: "Hoà",
  rCheckmate: "chiếu bí",
  rResign: "xin thua",
  rTimeout: "hết giờ",
  rStalemate: "hết nước đi",
  rAgreement: "thoả thuận",
  rAbandonment: "bỏ ván",
  rRepetition: "lặp thế cờ ba lần",
  rPerpetualCheck: "chiếu lặp",
  rPerpetualChase: "đuổi lặp",
  rDraw: "hoà",
  friends: "Bạn bè",
  friendsSub: "Kết bạn & thách đấu trực tiếp",
  addFriend: "Thêm bạn",
  friendUsername: "Nhập tên đăng nhập",
  send: "Gửi",
  requests: "Lời mời kết bạn",
  sentRequests: "Lời mời đã gửi",
  challenge: "Thách đấu",
  cancelChallenge: "Huỷ",
  remove: "Xoá",
  online: "Online",
  offline: "Offline",
  inGameNow: "Đang chơi",
  noFriends: "Chưa có bạn bè — thêm bạn bằng tên đăng nhập!",
  waitingForAccept: "Đang chờ đối phương đồng ý…",
  incomingChallenge: "Lời thách đấu",
  challengedYou: "thách đấu bạn một ván",
  challengeDeclinedMsg: "Lời thách đấu của bạn đã bị từ chối.",
  challengeCanceledMsg: "Lời thách đấu đã bị huỷ hoặc hết hạn.",
  signInForFriends: "Đăng nhập để kết bạn và thách đấu.",
  friendAdded: "Đã thêm bạn!",
  requestSent: "Đã gửi lời mời.",
  heroEyebrow: "Miễn phí · Chơi ngay trên trình duyệt",
  heroHead: "Làm chủ nghệ thuật ngàn năm của <span class=\"accent\">cờ tướng</span>",
  heroSub: "Thách đấu kỳ thủ khắp thế giới, mài giũa chiến lược và trải nghiệm cờ tướng trên một nền tảng tôn vinh truyền thống hàng trăm năm bằng công nghệ hiện đại.",
  playNow: "Chơi ngay",
  learnXiangqi: "Học cờ tướng",
  chooseMode: "Chọn chế độ",
  navPlay: "Chơi",
  navLearn: "Học",
  navRank: "Xếp hạng",
  navProfile: "Hồ sơ",

  playTitle: "Chơi",
  quickPair: "Ghép nhanh",
  quickPairNote: "Chọn một mức thời gian, bạn sẽ được ghép với người đang chờ đầu tiên ở mức đó.",
  openChallenges: "Lời thách đấu mở",
  openChallengesNote: "Đăng một lời thách đấu và ở lại trang này — ai cũng có thể nhận.",
  postSeek: "Đăng thách đấu",
  acceptChallenge: "Nhận",
  noOpenChallenges: "Chưa có lời thách đấu nào — bạn đăng trước nhé.",
  yourChallenge: "Thách đấu của bạn",
  playersOnline: "người online",
  gamesInPlay: "ván đang chơi",
  rated: "Xếp hạng",
  casual: "Giao hữu",
  catBullet: "Siêu chớp",
  catBlitz: "Cờ chớp",
  catRapid: "Cờ nhanh",
  catClassical: "Cờ chậm",
  timeControl: "Thời gian",
  seekWaitingNote: "Lời thách đấu của bạn đã hiện trong sảnh chờ — ai cũng có thể nhận.",
  botsNotice: "Chơi công bằng: khi không có người nào rảnh, bạn có thể được ghép với một đối thủ máy của chúng tôi.",
  opponentLeftGame: "Đối thủ của bạn đã rời ván.",
  notifications: "Thông báo",
  record: "Thành tích",
  rankNovice: "Nhập môn",
  rankApprentice: "Tập sự",
  rankAdept: "Thạo cờ",
  rankExpert: "Cao thủ",
  rankMaster: "Kiện tướng",
  rankGrand: "Đại kiện tướng",
  profToNext: "Còn {n} điểm lên {tier}",
  profTopRank: "Đã đạt hạng cao nhất",
  profForm: "Phong độ gần đây",
  profAll: "Tất cả",
  profTrend: "Diễn biến điểm",
  profLast10: "Điểm, 10 ván gần nhất",
  profStreakWin: "Chuỗi thắng",
  profStreakLoss: "Chuỗi thua",
  profNoMatch: "Không có ván nào khớp bộ lọc.",
  profStudy: "Tiến độ học",
  profContinue: "Học tiếp",
  profAsRed: "Cầm quân Đỏ",
  profAsBlack: "Cầm quân Đen",
  noNotifications: "Không có gì mới.",
  markAllRead: "Đánh dấu đã đọc hết",
  nFriendRequest: "đã gửi lời mời kết bạn",
  nFriendAccepted: "đã đồng ý kết bạn",
  nChallenge: "đã thách đấu bạn một ván",
  nMessage: "đã gửi tin nhắn cho bạn",
  messages: "Tin nhắn",
  messagesSub: "Trò chuyện với bạn bè",
  noConversations: "Chưa có cuộc trò chuyện nào — bắt đầu từ danh sách bạn bè.",
  writeMessage: "Viết tin nhắn…",
  sendMessage: "Gửi",
  messageFriendOnly: "Bạn chỉ có thể nhắn tin cho bạn bè.",
  emailNotifications: "Thông báo qua email",
  emailNotificationsSub: "Lời mời kết bạn, thách đấu và tin nhắn sẽ được gửi vào email của bạn.",
  emailUnavailable: "Máy chủ này chưa cấu hình email.",
  message: "Nhắn tin",
  backToMessages: "Về tin nhắn",
  noRatedGamesSub: "Bảng xếp hạng người chơi theo điểm. Chơi xong một ván xếp hạng là tên bạn sẽ xuất hiện ở đây.",
  heroBoardAlt: "Bàn cờ tướng gỗ trắc chạm khắc, quân đã bày sẵn cho nước đi đầu tiên",
  signInShort: "Đăng nhập",
  moreWays: "Thêm cách chơi",
  studyOn: "Học tiếp",
  leaderboardNote: "Chạm vào một người chơi để mở hồ sơ.",

  learnTitle: "Học",
  learnSub: "Bài học · thế cờ · luật chơi",
  continueLearning: "Tiếp tục",
  trainNow: "Luyện ngay",
  guideTitle: "Luật & ký hiệu",
  guideSub: "Bàn cờ, nước đi, kết quả và cách ghi nước",

  menu: "Menu",
  close: "Đóng",
  settings: "Cài đặt",
  settingsSub: "Ngôn ngữ, quân cờ, giao diện và âm thanh",
  sound: "Âm thanh",
  themeLight: "Sáng",
  themeDark: "Tối",
  quickMatch: "Ghép trận nhanh",
  quickMatchSub: "Ghép tôi với ai đó đang online ngay",
  lobbySub: "Xem và nhận các lời thách đấu mở",
  rejoinSub: "Bạn có một ván đang dở",
  liveNow: "Đang kết nối sảnh chờ…",
  playNowFree: "Tạo tài khoản miễn phí",
  sectionPlay: "Chơi",
  sectionPlaySub: "Đăng nhập để đấu với người hoặc với máy",
  sectionPlaySubIn: "Đấu với người hoặc với máy",
  sectionLearn: "Nâng trình",
  sectionLearnSub: "Ai cũng dùng được — không cần tài khoản",
  sectionCommunity: "Cộng đồng",
  sectionCommunitySub: "Xếp hạng, thành tích và bạn bè",
  accountRequired: "Cần có tài khoản để chơi",
  accountRequiredSub: "Chỉ mất khoảng mười lăm giây. Tài khoản lưu điểm, lịch sử ván đấu và bạn bè của bạn — và giữ cho các ván cờ công bằng với mọi người.",
  signInToPlay: "Đăng nhập hoặc tạo tài khoản để bắt đầu chơi.",
  loginSub: "Chào mừng trở lại — chơi tiếp từ chỗ bạn dừng.",
  signupSub: "Tạo tài khoản và bắt đầu hành trình cờ tướng của bạn.",
  whyAccount: "Vì sao cần tài khoản",
  perkRating: "Có điểm xếp hạng và chỗ trên bảng xếp hạng",
  perkHistory: "Mọi ván đều được lưu, xem lại đầy đủ",
  perkFriends: "Kết bạn và thách đấu trực tiếp",
  perkProgress: "Đồng bộ tiến độ bài học và thế cờ",
  // trang (tiêu đề hiện trên tab trình duyệt / lịch sử)
  brandName: "Xiangqi Master",
  pageHome: "Chơi cờ tướng online",
  notFoundTitle: "Không tìm thấy trang",
  notFoundBody: "Không có gì ở địa chỉ này — đường link có thể đã hết hạn, hoặc bị gõ sai.",
  resumingGame: "Đang mở lại ván của bạn…",
  liveGame: "Ván của bạn",
  quickMatchTitle: "Ghép trận nhanh",
  // công cụ bàn cờ
  pieceHints: "Gợi ý quân",
  pieceHintsSub: "Chấm nước đi hợp lệ và đánh dấu quân bị đe doạ",
  animations: "Hiệu ứng nước đi",
  voiceMoves: "Đọc nước đi",
  voiceMovesSub: "Đọc to từng nước khi được đi",
  focusMode: "Chế độ tập trung",
  focusModeSub: "Bàn cờ toàn màn hình, không gì khác",
  optOn: "Bật",
  optOff: "Tắt",
  // chặn khi chưa có tài khoản
  gateTitle: "Trang này cần tài khoản",
  gateBody: "Xếp hạng, hồ sơ, lịch sử ván đấu và bạn bè đều nằm trong tài khoản. Đăng nhập xong bạn sẽ quay lại đúng chỗ này.",
  gateWhere: "Sau khi đăng nhập, bạn sẽ tới:",
  signInShortcut: "Đăng nhập",
  // quên mật khẩu (mã gửi qua email)
  forgotLink: "Quên mật khẩu?",
  forgotTitle: "Đặt lại mật khẩu",
  forgotSub: "Nhập địa chỉ email của tài khoản, chúng tôi sẽ gửi cho bạn một mã sáu chữ số.",
  sendCode: "Gửi mã qua email",
  codeSent: "Đã gửi mã",
  codeSentSub: "Kiểm tra {email} và nhập mã sáu chữ số. Mã có hiệu lực trong mười phút.",
  codeLabel: "Mã sáu chữ số",
  verifyCode: "Xác nhận mã",
  resendCode: "Gửi lại",
  newPasswordTitle: "Chọn mật khẩu mới",
  newPasswordSub: "Mã hợp lệ. Hãy chọn mật khẩu mới — ít nhất tám ký tự.",
  newPassword: "Mật khẩu mới",
  confirmPassword: "Nhập lại mật khẩu mới",
  savePassword: "Lưu mật khẩu mới",
  passwordsDiffer: "Hai mật khẩu không khớp nhau.",
  passwordShort: "Mật khẩu phải có ít nhất 8 ký tự.",
  resetDone: "Đã đổi mật khẩu — bạn đã đăng nhập.",
  backToLogin: "Về đăng nhập",
  checkSpam: "Chưa nhận được? Kiểm tra thư mục spam, hoặc gửi lại sau một phút.",
  emailRequired: "Nhập địa chỉ email của bạn.",
  sending: "Đang gửi…",
  resetHowTitle: "Cách thực hiện",
  resetStep1: "Cho chúng tôi địa chỉ email của tài khoản, mã sẽ được gửi đi ngay.",
  resetStep2: "Nhập sáu chữ số — hiệu lực mười phút, tối đa năm lần thử.",
  resetStep3: "Chọn mật khẩu mới. Các thiết bị khác sẽ bị đăng xuất; thiết bị này vẫn đăng nhập.",
  // máy gặp trục trặc nhưng ván cờ vẫn tiếp tục
  engineHiccup: "Máy vừa bị trục trặc, nên nước vừa rồi được đi vội. Ván cờ vẫn tiếp tục.",
  hintFailed: "Không có gợi ý cho thế cờ này — thử lại sau giây lát.",
  // lời mời Discord
  discordTitle: "Tham gia cộng đồng của chúng tôi",
  discordBody: "Trò chuyện với người chơi khác, cùng xem lại ván cờ, và theo dõi những trao đổi hằng ngày về khai cuộc và tàn cuộc — ván đã xong được tự động đăng lên kênh.",
  discordJoin: "Tham gia cộng đồng",
  discordNo: "Để sau",
  discordPerk1: "Trò chuyện cờ tướng với người chơi khác",
  discordPerk2: "Mỗi ngày một thế cờ, và bình giải sau ván",
  discordPerk3: "Mọi ván đã xong đều được đăng",
  // xác nhận email cho tài khoản mới
  verifyTitle: "Xác nhận địa chỉ email",
  verifySub: "Chúng tôi đã gửi mã sáu chữ số tới {email}. Nhập mã là bạn có thể bắt đầu chơi.",
  verifyCta: "Xác nhận email",
  verifyLater: "Để sau",
  verifyDone: "Đã xác nhận địa chỉ — bạn có thể chơi rồi.",
  verifyGateTitle: "Hãy xác nhận email trước",
  verifyGateBody: "Chơi với người khác, gửi thách đấu và trò chuyện cạnh bàn cờ đều cần email đã xác nhận. Nhờ vậy các tài khoản ảo không lọt vào ván đấu.",
  verifyBannerText: "Email của bạn chưa được xác nhận, nên tạm thời chưa thể chơi với người.",
  verifyBannerCta: "Xác nhận ngay",
  verifyMeanwhile: "Trong lúc chờ, bạn vẫn có thể chơi với máy, học bài và giải thế cờ.",
  verifyHowTitle: "Vì sao cần bước này",
  verifyStep1: "Mã được gửi tới địa chỉ email bạn dùng để đăng ký.",
  verifyStep2: "Nhập sáu chữ số — hiệu lực 24 giờ, tối đa tám lần thử.",
  verifyStep3: "Nhập xong là mở khoá ván đấu với người, bạn bè và trò chuyện.",
  verifySent: "Một mã mới đang được gửi tới.",
  verifyNoCode: "Chưa nhận được? Kiểm tra thư mục spam, hoặc gửi lại.",
  // trang Học
  learnKicker: "Học · Học viện",
  learnHeadline: "Từ cách các quân đi đến cách thắng một ván cờ",
  learnBlurb: "Mười bảy bài học tương tác, các thế cờ chiến thuật và máy để kiểm tra ván của chính bạn — tất cả đều chơi trên bàn cờ thật, không phải đọc chay trên giấy.",
  yourProgress: "Tiến độ của bạn",
  lessonsLabel: "Bài học",
  puzzlesLabel: "Thế cờ",
  nextUp: "Tiếp theo",
  allDoneReview: "Đã xong hết — ôn lại",
  pathTitle: "Lộ trình",
  pathSub: "Năm chặng, theo thứ tự hợp lý nhất",
  toolsTitle: "Công cụ học",
  toolsSub: "Dành cho khi bạn đã học xong các bài",
  boardThemeSub: "Hai mươi bảy kiểu bàn cờ. Đổi bất cứ lúc nào, kể cả giữa ván.",
  groupAppearance: "Hiển thị",
  groupAppearanceSub: "Quân cờ, giao diện và ngôn ngữ",
  groupPlay: "Khi chơi",
  groupPlaySub: "Cách bàn cờ hoạt động trong ván đấu",
  groupAccount: "Tài khoản",
  groupAccountSub: "Email và thông báo",
  whyCheckOnly: "Nước đó chiếu được, nhưng đối phương có cách đỡ và đòn tấn công hết đà. Hãy tìm nước mang tính ép buộc.",
  whyHangs: "Sau nước đó, quân {piece} bị ăn ngay.",
  whyWinsButNot: "Nước đó được quân, nhưng không phải nước mà bài này muốn dạy.",
  whyQuiet: "Hợp lệ, nhưng không hoàn thành nhiệm vụ — nó cho bên phòng thủ thời gian củng cố.",
  pieceKing: "Tướng",
  pieceAdvisor: "Sĩ",
  pieceElephant: "Tượng",
  pieceHorse: "Mã",
  pieceRook: "Xe",
  pieceCannon: "Pháo",
  pievePawn: "Tốt",
  quizTitle: "Tự kiểm tra",
  quizRight: "Đúng",
  quizWrong: "Chưa đúng",
  stepOf: "Bước {n}/{t}",
  continueStep: "Tiếp tục",
  chatTitle: "Trò chuyện",
  chatPlaceholder: "Nói gì đó…",
  isTyping: "{name} đang nhập…",
  settingsIntro: "Cứ thử thoải mái, rồi bấm Lưu ở góc trên bên phải để giữ lại. Rời đi mà không lưu thì mọi thứ trở về như cũ.",
  settingsSave: "Lưu",
  settingsSaved: "Đã lưu",
  settingsUnsaved: "Chưa lưu thay đổi",
  dPieces: "Chữ Hán phồn thể, giản thể, chữ cái hoặc ký hiệu",
  dTheme: "Giao diện sáng hoặc tối",
  dScene: "Khung cảnh và thời tiết phía sau bàn cờ",
  dLanguage: "Ngôn ngữ của toàn bộ giao diện",
  dHints: "Hiện nước đi hợp lệ của quân đang chọn, và đánh dấu quân bị đe doạ",
  dAnim: "Quân trượt đi khi di chuyển",
  dSound: "Âm thanh khi đi quân, chiếu và kết thúc ván",
  dVoice: "Đọc to từng nước đi",
  dEmail: "Gửi email cho tôi khi có lời mời chơi và lời mời kết bạn",
  dailyReminders: "Email bài học",
  dDaily: "3 ngày một lần: một bài học, một thế cờ và một bài đáng đọc",
  dBoardTheme: "Hai mươi bảy kiểu bàn cờ. Đổi bất cứ lúc nào, kể cả giữa ván.",
  megaStart: "Bắt đầu ván",
  megaPeople: "Kỳ hữu",
  megaTrain: "Luyện tập",
  megaReference: "Tra cứu",
  boardTheme: "Kiểu bàn cờ",
  refTitle: "Tra cứu luật",
  refSub: "Mỗi luật một trang riêng, kèm bàn cờ đi thử được",
  refPieces: "Cách đi của từng quân",
  refPiecesSub: "Cả bảy loại, lần lượt từng quân",
  refFlying: "Lộ mặt tướng",
  refFlyingSub: "Vì sao hai Tướng không bao giờ được đối mặt",
  refRepetition: "Chiếu lặp & đuổi lặp",
  refRepetitionSub: "Cách xử nước lặp, theo chuẩn WXF",
  refOpenings: "Tra cứu khai cuộc",
  refOpeningsSub: "Pháo đầu, Bình phong Mã và ý tưởng đằng sau",
  refAll: "Xem toàn bộ tra cứu",
  startLesson: "Bắt đầu bài này",
  resumeLesson: "Học tiếp bài này",
  groupComplete: "Hoàn thành",
  groupLessons: "bài học",
  groupLesson: "bài học",
  howTitle: "Cách tiến bộ nhanh",
  howStep1: "Học cách đi quân",
  howStep1Sub: "Tám bài ngắn về từng quân và những luật hay khiến người quen chơi cờ vua bị vấp — bài nào cũng chơi thử được trên bàn cờ.",
  howStep2: "Luyện chiến thuật",
  howStep2Sub: "Bắt đôi, ghim quân và chiếu bí một nước: những đòn quyết định ván cờ phong trào, luyện tới khi nhìn là thấy.",
  howStep3: "Xem lại ván của bạn",
  howStep3Sub: "Xem lại ván của chính bạn trên bàn phân tích và để máy chỉ ra nước đã làm bạn thua.",
  minLesson: "khoảng 2 phút",
  lessonsAllDone: "Bạn đã học xong mọi bài — tiếp theo hãy giải thế cờ, hoặc xem lại một ván trên bàn phân tích.",

  // ---- xem ván ----
  watchTitle: "Xem cờ",
  watchSub: "Theo dõi một ván đang được chơi ngay lúc này",
  watchGameTitle: "Đang xem",
  watchLoading: "Đang vào ván…",
  gamesInPlayTitle: "Ván đang diễn ra",
  watchNote: "Các ván công khai được liệt kê ở đây. Ván tạo bằng mã phòng riêng thì không bao giờ hiện ở đây — chỉ mở được bằng link do một trong hai người chơi chia sẻ.",
  noLiveGames: "Hiện không có ai đang chơi",
  noLiveGamesSub: "Bắt đầu một ván hoặc đăng lời thách đấu mở, và người khác sẽ xem bạn chơi.",
  watching: "đang xem",
  watchingReadOnly: "Đang xem: bạn có thể trò chuyện, nhưng không được đi quân.",
  watchLink: "Link xem",
  shareThisGame: "Chia sẻ ván này",
  copyWatchLink: "Sao chép link xem",
  watchGoneTitle: "Ván đó đã kết thúc",
  watchGoneBody: "Chỉ xem được ván khi nó đang diễn ra. Nếu là ván công khai, bạn vẫn có thể xem lại.",
  moveNo: "nước",

  // ---- thông báo đẩy ----
  pushNotifications: "Thông báo đẩy",
  dPush: "Lời mời kết bạn và thách đấu trên thiết bị của bạn, kể cả khi đã đóng trang",
  pushEnable: "Bật",
  pushBlocked: "Bị chặn",
  pushBlockedNote: "Thông báo đang bị chặn với trang này — hãy cho phép trong phần cài đặt trang của trình duyệt.",
  pushUnsupported: "Trình duyệt này không hiển thị được thông báo đẩy.",
  pushOnNote: "Đã bật cho thiết bị này. Không có thông báo nào khi bạn đang mở trang.",
  pushFailed: "Không thành công. Thử lại sau giây lát.",
  pushServerOff: "Máy chủ này chưa bật thông báo đẩy.",
};
